'use client';

import { useCallback, useState } from 'react';
import { Icon } from '@/app_components/common/Icon';
import { SpinningLoader } from '@/app_components/icons/SpinningLoader';
import { SignInTitle } from '@/app_components/SignIn/Components/SignInSharedComponents';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { clearSignInRedirectCookie, getSignInRedirectDestination } from '@/app_lib/utils/signinRedirect';

export const SignInAccountCreationConfirmation = () => {
  const [continueHref] = useState(() => getSignInRedirectDestination());
  const [loading, setLoading] = useState(false);

  const handleContinueClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      clearSignInRedirectCookie();
      setLoading(true);
      window.location.href = continueHref;
    },
    [continueHref],
  );

  return (
    <div className='flex w-full flex-col items-center gap-xl font-graphik-compact'>
      <Icon
        className='stroke-green-400 fill-green-50'
        icon='CircleCheck'
        mode='custom'
        size='xl'
        strokeWidth={2}
      />
      <div className='flex flex-col items-center gap-xl w-full'>
        <SignInTitle title='Account created successfully' />
        <ButtonV2
          aria-disabled={loading}
          as='a'
          className='w-fit max-h-12'
          href={continueHref}
          onClick={handleContinueClick}
          size='lg'
          variant='primary'
        >
          {loading ? <SpinningLoader /> : 'Continue'}
        </ButtonV2>
      </div>
    </div>
  );
};
